export const FETCH_CARE_ROUND = "app/CareRound/FETCH_CARE_ROUND";
export const FETCH_CARE_ROUND_SUCCESS =
  "app/CareRound/FETCH_CARE_ROUND_SUCCESS";
export const FETCH_CARE_ROUND_FAILURE =
  "app/CareRound/FETCH_CARE_ROUND_FAILURE";

export const ADD_CARE_ROUND = "app/CareRound/ADD_CARE_ROUND";
export const ADD_CARE_ROUND_SUCCESS = "app/CareRound/ADD_CARE_ROUND_SUCCESS";
export const ADD_CARE_ROUND_FAILURE = "app/CareRound/ADD_CARE_ROUND_FAILURE";

export const FETCH_CARE_ROUND_ITEM = "app/CareRound/FETCH_CARE_ROUND_ITEM";
export const FETCH_CARE_ROUND_ITEM_SUCCESS =
  "app/CareRound/FETCH_CARE_ROUND_ITEM_SUCCESS";
export const FETCH_CARE_ROUND_ITEM_FAILURE =
  "app/CareRound/FETCH_CARE_ROUND_ITEM_FAILURE";

export const EDIT_CARE_ROUND = "app/CareRound/EDIT_CARE_ROUND";
export const EDIT_CARE_ROUND_SUCCESS = "app/CareRound/EDIT_CARE_ROUND_SUCCESS";
export const EDIT_CARE_ROUND_FAILURE = "app/CareRound/EDIT_CARE_ROUND_FAILURE";

export const DELETE_CARE_ROUND = "app/CareRound/DELETE_CARE_ROUND";
export const DELETE_CARE_ROUND_SUCCESS =
  "app/CareRound/DELETE_CARE_ROUND_SUCCESS";
export const DELETE_CARE_ROUND_FAILURE =
  "app/CareRound/DELETE_CARE_ROUND_FAILURE";

export const SET_CARE_ROUND_ADD_EDIT_MODAL =
  "app/CareRound/SET_CARE_ROUND_ADD_EDIT_MODAL";
